import cn from "./style.module.css"

export const Header = () => {
  return (
    <div className={cn.headerWrapper}>
      <div className={cn.logoBlock}>welcome to hurry</div>
    </div>
  )
}